import { defineAsyncComponent } from "vue";
import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
import { useUserStore } from "@/stores/user";

const contractRouters: RouteRecordRaw[] = [
    {
        path: "/warehouseContract",
        name: "WarehouseContract",
        meta: {
            title: "合同管理",
            isNotShowHeader: true,
            activeMenu: "WarehouseContract",
            pageType: PAGE_TYPE.LIST.code,
            keepAlive: true
        },
        component: defineAsyncComponent(() => {
            const userStore = useUserStore();
            if (userStore?.isSAAS) {
                return import("@/components/emptyPage/index.vue");
            } else {
                return import("@/views/pages/warehouseSupervision/contractManagement/index.vue");
            }
        })
    },
    {
        path: "/warehouseContract/contractDetail",
        name: "WarehouseContractDetail",
        meta: { title: "合同详情", hidden: true, activeMenu: "WarehouseContract" },
        component: () => import("@/views/pages/warehouseSupervision/contractManagement/detail.vue")
    }
];

export default contractRouters;
